<template>
  <AppLayoutFull>
    <div class="signin">
      <a href="#" class="nav-link inactive" v-if="!authenticated" @click="login">Login</a>
      <a href="#" class="nav-link inactive" v-if="authenticated" @click="logout">Logout</a>
      <!-- <a href="#" class="nav-link inactive" @click="apiPublic">public</a>
      <a href="#" class="nav-link inactive" @click="apiPrivate">private</a>-->
      <a href="#" class="nav-link inactive">{{ msg }}</a>
    </div>
  </AppLayoutFull>
</template>

<script>
// import axios from 'axios'

import AppLayoutFull from "../components/AppLayoutFull";

// axios.interceptors.request.use(
//   async config => {
//     if (auth.currentUser) {
//       config.headers.token = await auth.currentUser.getIdToken()
//     }
//     return config
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )
export default {
  name: "Login",
  components: { AppLayoutFull },
  data: function() {
    return {
      user: {
        loggedIn: false,
        data: {}
      },
      email: "",
      password: "",
      msg: "Welcome to Your Vue.js App"
    };
  },
  computed: {
    authenticated() {
      return this.user.loggedIn;
    }
  },
  methods: {
    login() {
      this.$store.dispatch("signIn");
    },
    logout() {
      this.$store.dispatch("signOut");
    }
    // apiPublic: async function() {
    //   let res = await axios.get('http://localhost:8000/public')
    //   this.msg = res.data
    // },
    // // apiPrivate: async function() {
    // //   let res = await axios.get('http://localhost:8000/private')
    // //   this.msg = res.data
    // // },

    // apiPrivate: async function() {
    //   let res = await axios.get('http://localhost:8000/private')
    //   // , {
    //   //   headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` }
    //   // })
    //   this.msg = res.data
    // }
  }
  // mounted: function() {
  //   auth.onAuthStateChanged(user => {
  //     if (user) {
  //       this.user.loggedIn = true
  //       this.user.data = user
  //     } else {
  //       this.user.loggedIn = false
  //       this.user.data = {}
  //     }
  //   })
  // }
};
</script>
